const actions = {
  detachB2bUser(context, payload) {
    context.getters.userInstance.queryDetachB2bUser(payload, (response) => {
      if (response.data.removeB2bUser.error === null) {
        context.dispatch('userRefresh').then(() => {
          context.commit('removeRecipientFromGlobalCart', {
            companyContactId: payload.id
          });
          // Sync updated cart with Shopify temp orders for all affected markets
          context.dispatch('processCarts').then(() => {});
          // Refresh B2B contacts list to update UI
          context.dispatch('refreshB2BContacts');
        });
      }
    });
  },
  getB2BUser(context, payload) {
    context.getters.userInstance.getB2BUser(payload, (response) => {
      if (response) {
        return response;
      }
    });
  },
  editB2BUser(context, payload) {
    context.getters.userInstance.editB2BUser(payload, (response) => {
      if (response) {
        context.dispatch('userRefresh').then(() => {});
      }
    });
  }
};

export default actions;
